import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { RouteProps } from "react-router";
import Content from "Types/Content";
import useSpaceGame from "./useSpaceGame";
import "./style.scss";

const SpaceInvaders: React.FC<RouteProps> = () => {
  useEffect(() => {
    document.body.style.backgroundColor = "#2d3436";
  }, []);

  const [
    areaSize,
    playerPosition,
    playerSize,
    aliens,
    alienSize,
    lazers,
    lazerSize,
    explosions,
    gameOver,
    points,
    setGameStarted
  ] = useSpaceGame();

  return (
    <Container>
      <div
        className='game-info'
        style={{
          width: areaSize[0] * 8
        }}>
        <h5 className='text'>Bienvenido a la copia barata de Space Invaders</h5>
        <div className='text'>Controles: Flechas|WASD - Espacio</div>
        {gameOver && points !== 0 && <h6 className='text'>Perdiste</h6>}
        {gameOver && (
          <input
            onClick={() => setGameStarted(true)}
            type='button'
            value='Comenzar'
          />
        )}
        {!gameOver && <h6 className='text'>Puntaje: {points}</h6>}
      </div>
      <div
        className='game-canvas'
        style={{
          width: areaSize[0] * 8,
          height: areaSize[1] * 8
        }}>
        {aliens.map(a => {
          return (
            <div
              className={
                "game-entity " + (a.variation >= 2 ? "alien1" : "alien2")
              }
              style={{
                width: alienSize[0] * 8,
                height: alienSize[1] * 8,
                left: a.position[0] * 4,
                top: a.position[1] * 4
              }}></div>
          );
        })}
        {lazers.map(l => {
          return (
            <div
              className='game-entity lazer'
              style={{
                width: lazerSize[0] * 8,
                height: lazerSize[1] * 8,
                left: l.position[0] * 4,
                top: l.position[1] * 4
              }}></div>
          );
        })}
        {explosions.map(e => {
          return (
            <div
              className={
                "game-entity " + (e.type === 0 ? "explosion" : "alien-pop")
              }
              style={{
                width: 1 * 8,
                height: 1 * 8,
                transform: "scale(" + (e.type === 0 ? e.size : 3) + ")",
                left: e.position[0] * 4,
                top: e.position[1] * 4
              }}></div>
          );
        })}
        <div
          className='game-entity player'
          style={{
            width: playerSize[0] * 8,
            height: playerSize[1] * 8,
            left: playerPosition[0] * 4,
            top: playerPosition[1] * 4
          }}></div>
      </div>
    </Container>
  );
};

export default new Content({
  Component: SpaceInvaders,
  title: "Space Invaders",
  route: "space-invaders"
});
